import { ApiResponse } from 'apisauce';
import { Api } from './api';

export interface TPaymentType {
  createdBy: string | null;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  active: boolean;
  id: string;
  name: string;
  description: string | null;
}
export class PaymentTypeApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }
  async getPaymentType(): Promise<TPaymentType[] | undefined> {
    const response: ApiResponse<TPaymentType[]> =
      await this.api.apisauce.get(`payment-type`);
    if (!response.ok) {
      throw response.originalError;
    }
    return response.data;
  }
}
